import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import BannerEdApp from '../components/BannerEdApp'
import { Link } from 'gatsby'

import discussionapp1 from '../assets/images/discussionapp1.png'
import discussionapp2 from '../assets/images/discussionapp2.png'
import discussionapp3 from '../assets/images/discussionapp3.png'
import pastwork from '../assets/images/pastwork.png'
import profile from '../assets/images/profile.png'
import social from '../assets/images/social.png'
import dictionary20201 from '../assets/images/dictionary20201.png'
import dictionary20202 from '../assets/images/dictionary20202.png'


const EdApp = (props) => (
    <Layout>
        <Helmet>
            <title>EdApp</title>
            <meta name="description" content="Generic Page" />
        </Helmet>

        <BannerEdApp />

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <p>Here are some educational app designs that came out of my imagination!</p>
                    <p>Some may turn into reality in the future by hard work of my husband, who is a software developer, or remain in my head (and this place) forever. Hope the list gives someone some idea or insight that might help their current or future projects.</p>            

                    <p>***</p>

                    <div className="grid-wrapper">
                        <div className="col-6">
                            <header className="major">
                                <h2>Current Project - Online Discussion App</h2>
                            </header>
                            <p>This is the most recent discussion app interface design I've been working on for a few months. I know this will turn into actual product and will use it for my own teaching practice. Unlike existing discussion platforms, it has both thread and network views of discussion boards students can choose depending on their preferences. One of the two images show how the discussion board looks like in a network view.</p>
                        </div>
                        <div className="col-3"><img src={discussionapp2} alt="" /></div>
                        <div className="col-3"><img src={discussionapp3} alt="" /></div>
                    </div>

                    <p>Below is the wireframe of the overall design. I am still in the middle of working on the initial wireframe design and may update on this project as I progress.</p>
                    <img src={discussionapp1} alt="" />

                    <header className="major">
                        <h2>Past Works</h2>
                    </header>

                    <h3>"LangCraft"</h3>
                    <p>This is one of the very early designs when I started learning about coding and user interface design. The app was intended for users learning a second language.</p>
                    <div className="grid-wrapper">
                        <div className="col-4"><img src={pastwork} alt="" /></div>
                        <div className="col-4"><img src={profile} alt="" /></div>
                        <div className="col-4"><img src={social} alt="" /></div>
                    </div>

                    <h3>"Dictionary"</h3>
                    <p>Again, this is one of the very early designs. It's also one of the initial designs for <Link to="/analytics" className="link primary">Dictionary</Link>. The design will not be used for Dictionary but I might use some elements for my future works.</p>
                    <img src={dictionary20201} alt="" />
                    <img src={dictionary20202} alt="" />
                </div>
            </section>
        </div>
    </Layout>
)

export default EdApp